import { defineComponent as _defineComponent } from 'vue'
import TableauPopup from "../../ui-components/TableauPopup.vue";
import TableauButton from "../../ui-components/TableauButton.vue";
import TableauRichTextBox from "../../ui-components/TableauRichTextBox.vue";
import TableauSimpleAutocomplete from "../../ui-components/TableauSimpleAutocomplete.vue";
import { container } from "tsyringe";
import { AdvancedExportModule, CategoricalFilterInfo } from "./advanced-export.module";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IterationFilterSelectorPopup',
  props: {
    initialValue: { type: Object, required: false },
    allExistingFilters: { type: Array, required: true },
    allPossibleFilterNames: { type: Promise, required: true },
    onSubmit: { type: Function, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const module = container.resolve(AdvancedExportModule);


const status = ref<"idle" | "loading" | "success" | "error">("idle");
const filterName = ref<string>(props.initialValue?.name || "");
const filterValueText = ref<string>(props.initialValue?.values?.join("\n") || "");

const filterValues = computed(() => {
  return (filterValueText.value || "").split("\n").filter((e) => !!e);
});
const submitInfo = computed(() => {
  if (!filterName.value || filterValues.value.length === 0) {
    return { canSubmit: false, text: "" };
  }
  if (
    !!props.allExistingFilters.find((e) => e.name === filterName.value) &&
    props.initialValue?.name !== filterName.value
  ) {
    return { canSubmit: false, text: "Filter already set" };
  }
  return { canSubmit: true, text: "" };
});

const actionLink = computed(() => {
  if (props.initialValue) {
    return {
      text: "Delete configuration",
      action: () => props.onSubmit({ cmd: "remove", filter: undefined }),
    };
  }
  return undefined;
});

function set() {
  props.onSubmit({
    cmd: "add",
    filter: {
      name: filterName.value,
      values: filterValues.value,
    },
  });
}

const __returned__ = { module, props, status, filterName, filterValueText, filterValues, submitInfo, actionLink, set, TableauPopup, TableauRichTextBox, TableauSimpleAutocomplete }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})